import { CheckCircleFilled } from '@ant-design/icons';
import { Button, Flex, Typography } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { GreenPrimary } from '../../styles';

const { Text, Title } = Typography;

const StyledFlex = styled(Flex)`
  margin-top: calc(100vh * 0.175);
`;

const StyledCheckCircle = styled(CheckCircleFilled)`
  color: ${GreenPrimary};
  font-size: 70px;
`;

const StyledText = styled(Text)`
  text-align: center;
`;

function UploadSuccessful() {
  const navigate = useNavigate();

  return (
    <StyledFlex vertical align="center" gap={16}>
      <Flex vertical align="center" gap={2}>
        <StyledCheckCircle />
        <Title level={3}>Success!</Title>
        <StyledText type="secondary">
          Your transcripts are in, and Fathom AI is processing your interview guide.
        </StyledText>
        <StyledText type="secondary">
          Feel free to step away — we&apos;ll email you when it&apos;s time to review your analysis.
        </StyledText>
      </Flex>
      <Button type="primary" size="large" onClick={() => navigate('/')}>
        Go to My Projects
      </Button>
    </StyledFlex>
  );
}

export default UploadSuccessful;
